import Vue from "vue";
import VueRouter from "vue-router";

import foodsInfo from "@/views/foods/FoodsInfo.vue";
import serachFoods from "@/views/foods/SerachFoods.vue";
import Home from '@/views/home/Home.vue'
// import comment from "@/views/comment/Comment.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Home,
    // redirect: { name: "serachFoods" },
  },
  {
    path: "/foodsInfo",
    name: "foodsInfo",
    component: foodsInfo,
  },
  {
    path: '/home',
    name: 'Home',
    component:()=>import('@/views/home/Home.vue')
  },
	{
		path: '/nutrition',
		name: 'nutrition',
		component: ()=>import('@/views/home/component/nutrition.vue')
	},
  {
    path: "/serachFoods",
    name: "serachFoods",
    component: serachFoods,
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/test/index.vue"),
  },
  {
    path: "/leaveInfo",
    name: "leaveInfo",
    component: () => import("@/views/leave/LeaveInfo.vue"),
  },
  {
    path: "/comment",
    name: "comment",
    // component: comment,
    component: ()=>import("@/views/comment/index.vue"),
  },
  {
    path: "*",
    redirect: { name: "index" },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
